import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from './composants/Header';
// import Footer from './components/Footer.jsx';
import Router from './Router';



const App = () => {
  return (
    <BrowserRouter>


      <Header />

      <main>
        <Router />
      </main>
      {/* <Footer /> */}

    </BrowserRouter>
  );
};

export default App;
